export class AssocierDocumentAuProduit {
    documentId: string;
    produitId: string;
    selected: boolean;
}